:host {
  display: block;
}

.header-container {
  width: 100%;
  background-color: var(--color-white);
  box-sizing: border-box;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &.sticky {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 50;
  }

  .partner-logo-devider {
    width: 2px;
    height: 44px;
    background-color: var(--color-steel-200);
    margin-right: var(--spacing-m);
  }

  .portal-name {
    @apply font-text-bold text-copy;
    color: var(--color-black);
  }

  .menu-button {
    border: none;
    outline: none;
    background: none;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .bar1,
    .bar2 {
      transition: 0.3s;
      -webkit-transform-origin: center;
      transform-origin: center;
    }

    &.mobile-menu-open {
      //close button
      .bar1 {
        -webkit-transform: rotate(45deg) translate(-8px, 8px);
        transform: rotate(45deg) translate(-8px, 8px);
      }
      .bar2 {
        -webkit-transform: rotate(-45deg) translate(-8px, -8px);
        transform: rotate(-45deg) translate(-8px, -8px);
      }
    }
  }

  .mobile-menu {
    position: relative;
    background-color: var(--color-steel-100);
    z-index: 50;
    height: calc(100vh - 70px);

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

    li {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      margin: 0;
      padding: 0;
      @apply font-text-bold text-copy;
    }

    .mobile-menu-tabitem-wrapper {
      border-bottom: 1px solid var(--color-steel-400);

      &.subitem {
        background-color: var(--color-steel-200);
      }
    }

    .mobile-menu-expand-subitems-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 80px;
      cursor: pointer;
    }

    .mobile-menu-tabitem,
    .mobile-menu-subitem,
    .mobile-menu-sub-subitem {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 80px;
      padding-right: 12px;
      overflow: hidden;
      cursor: pointer;

      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .mobile-menu-sub-subitem {
      background-color: var(--color-steel-300);
      border-bottom: 1px solid var(--color-steel-400);
      padding: 0 24px 0 60px;
    }
  }

  .tabitem-menu {
    position: relative;
    background-color: var(--color-steel-100);
    width: 100%;
    z-index: 50;
    height: calc(100vh - 70px);

    /* Tablet+ */
    @media (min-width: theme('screens.sm')) {
      height: calc(100vh - 90px);
    }

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

    li {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      margin: 0;
      padding: 0;
      font-family: var(--headline-font-family);
      font-size: var(--h4-font-size);
    }

    .tabitem-menu-tabitem-wrapper {
      display: flex;
      width: 224px;
      padding: 0 0 24px 0;
      cursor: pointer;

      .tabitem-menu-tabitem-underline {
        background-image: linear-gradient(to bottom, transparent 20%, var(--color-black) 21%);
        background-position: 0 1em;
        background-repeat: no-repeat;
        background-size: 0% 4px;
        transition: background-size 0.5s ease-in-out;
        text-transform: uppercase;
        line-height: 44px;

        &:hover {
          background-size: 100% 4px;
          transition-delay: 0s;
        }
      }
    }

    .tabitem-menu-subitem-container {
      display: flex;

      &:hover .tabitem-menu-tabitem-underline {
        background-size: 100% 4px;
        transition-delay: 0s;
      }

      .tabitem-menu-sub-subitem-container {
        position: relative;
        display: contents;

        ul {
          display: none;
          flex-direction: column;
          position: absolute;
          left: 448px;
          width: 100%;
        }

        li {
          font-size: 24px;
        }

        .tabitem-menu-sub-subitem-wrapper {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 0 0 24px 48px;
          cursor: pointer;
          width: 100%;
          min-height: 48px;

          &:hover {
            font-family: var(--headline-font-family);
          }
        }
      }

      &:hover .tabitem-menu-sub-subitem-container {
        ul {
          display: inline-flex;
        }
      }
    }
  }
}

.header-wrapper {
  position: relative;
  grid-template-columns: auto 1fr;

  @apply min-h-[70px] lg:min-h-[90px];

  /* has portal or partner logo */
  &.portal {
    grid-template-columns: auto auto;
  }
}

/* Tablet */
@media (min-width: theme('screens.sm')) {
  .header-wrapper {
    gap: var(--spacing-xl);

    &.portal {
      grid-template-columns: auto auto 1fr;
    }
  }
}

/* Desktop */
@media (min-width: theme('screens.lg')) {
  .header-wrapper {
    grid-template-columns: auto 1fr auto;

    &.portal {
      grid-template-columns: auto auto 1fr auto;
    }
  }
}

/* Selects any <patternlib-main-navigation> placed inside a slot */
::slotted(patternlib-main-navigation) {
  @apply pt-4 pb-4;
}

.burger-wrapper {
  position: relative;
  display: inline-block;
}
.burger-wrapper patternlib-badge {
  position: absolute;
  top: 0px;
  right: -10px;
}
